import { axios } from '@/services/axios';

const updateCustomSIPHeader = async (formData, currentScope) => {
    const res = await axios.put('/TRECustomHeader', formData, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default updateCustomSIPHeader;
